// src/pages/Fees.js
import React from "react";
import { Link } from "react-router-dom";
import "../styles/fees.css";

export default function Fees() {
  return (
    <div className="fees-page container my-5">
      <div className="fees-card p-4">
        <h2 className="fees-title">Fees & Scholarships</h2>

        <p className="lead mb-3">
          💰 Base Fee: <strong>₹65,000</strong> + 18% GST
        </p>

        {/* Eligibility */}
        <div className="eligibility-box mb-4">
          <strong>Eligibility:</strong>
          <p className="mb-0">
            B.Com. graduates<em>,</em>other grads and Class 12 (Commerce) students are eligible to apply.
            Class 12 students can enroll by selecting <em>Class 12 (Commerce)</em> in the registration form.
          </p>
        </div>

        {/* Admission Process */}
        <h3 className="section-heading">Admission Process</h3>
        <p>
          Concerted Path follows a rigorous and scientifically developed admission process to
          assess students for a successful career path. Enroll yourself and give the online
          Entrance Test on{" "}
          <a
            href="https://concertedpath.com/"
            target="_blank"
            rel="noreferrer"
          >
            https://concertedpath.com/
          </a>.
        </p>

        <p className="mb-2"><strong>Pass / Scholarship criteria:</strong></p>
        <ul className="criteria-list mb-3">
          <li>Minimum <strong>50%</strong> marks required for Admission.</li>
          <li>Minimum <strong>75%</strong> marks required to qualify for Scholarship Program.</li>
        </ul>

        <ol className="admission-steps mb-4">
          <li><strong>Step 1</strong> - Fill Admission Form.</li>
          <li>
            <strong>Step 2</strong> - Submit Required Documents:
            <ul className="sublist">
              <li>B.Com. Final year admission acknowledgement or B.Com. score card & Aadhaar card</li>
              <li>OR Class 12 (Commerce) provisional marks / certificate</li>
            </ul>
          </li>
          <li><strong>Step 3</strong> - Deposit the Fee.</li>
          <li>Select batch and start classes.</li>
        </ol>

        <h4 className="section-heading">Scholarship Calculation</h4>
        <p>The scholarship applied to base fee will be decided as per the admission test score range:</p>
        <ul className="scholarship-list mb-4">
          <li>75% to 84% marks → <strong>25% scholarship</strong></li>
          <li>85% to 94% marks → <strong>35% scholarship</strong></li>
          <li>95% to 100% marks → <strong>50% scholarship</strong></li>
        </ul>

        <p className="mb-2">
          <strong>Retake policy:</strong> If the student obtains less than 50% marks they will not be
          eligible for admission immediately but will be given <strong>3 chances</strong> to clear the test
          with a minimum gap of 7 days between attempts.
        </p>

        <p className="mb-4 final-note">
          Once qualified, the student can take admission by depositing the fee and selecting a batch.
        </p>

        {/* Golden Enroll Button */}
        <div className="text-center mt-4">
          <Link to="/register" className="btn-enroll">
            Enroll Now
          </Link>
        </div>
      </div>
    </div>
  );
}
